import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const monitoringEventAPI = createApi({
  baseQuery,
  reducerPath: 'monitoringEventAPI',
  endpoints: builder => ({
    getMonitoringEvent: builder.query<any, any>({
      query: ({ study_id, country, site_id, application, visit_type = '' }) => ({
        url: `${formatString(endPoints.monitoringEvent.getAll)}?${
          visit_type !== '' ? `visit_type=${visit_type}&` : ''
        }${study_id !== null ? `study_id=${study_id}` : ''}${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=SUBJECT TRACKING`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    selectMonitoringEvent: builder.query<any, any>({
      query: ({ id, study_id, country, site_id }) => ({
        url: `${formatString(endPoints.monitoringEvent.getAll, { key: urlKeys.id, value: id })}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=CTMS&application_section=CONDUCT&application_module_section=SUBJECT TRACKING`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createMonitoringEvent: builder.mutation<any, any>({
      query: ({ data, study_id, country, site_id }) => ({
        url: `${formatString(
          endPoints.monitoringEvent.create,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.site_id, value: site_id }
        )}?application=CTMS&application_section=CONDUCT&application_module_section=SUBJECT TRACKING`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateMonitoringEvent: builder.mutation<any, any>({
      query: ({ id, data, study_id, country, site_id, application }) => ({
        url: `${formatString(
          endPoints.monitoringEvent.update,
          { key: urlKeys.id, value: id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.site_id, value: site_id }
        )}?application=${application}&application_section=CONDUCT&application_module_section=SUBJECT TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetMonitoringEventQuery,
  useLazySelectMonitoringEventQuery,
  useCreateMonitoringEventMutation,
  useUpdateMonitoringEventMutation
} = monitoringEventAPI;
